import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subject, Subscription } from 'rxjs';
import { APP_Constants } from 'src/app/app.constant';
import { AppService } from 'src/app/app.service';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
import { CustomSnackBarService } from 'src/app/common/snack-bar/snack-bar.service';
import { Constant } from '../../constants/constants';


@Component({
    selector: 'app-stepper-content',
    templateUrl: './stepper-content.component.html',
    styleUrls: ['./stepper-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StepperContentComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() configData;
  @Input() frmGroup: UntypedFormGroup;
  @Output() loadingStatus = new EventEmitter();

  subscription: Subscription;
  hideSection: boolean = true;
  hideField: boolean = true;
  customerCode: string;
  editField: boolean;
  enablesubLabel: boolean= false;
  flagAdd: boolean;
  selfServiceConfig : boolean = false;
  lableForConfig: any;
  templateData: any;
  orderFormSubmitted: any;
  orderForm: any;
  templatedata: any;
  formError: string;
  isLoading: boolean;
  durationInSeconds: number;
  totalError : any = 0;
  constant : any = Constant;
  
  constructor(private appService: AppService, private _snackBar: CustomSnackBarService, private changeDetector: ChangeDetectorRef,private router: Router,private modalService: ModalService) { }

  ngOnInit() {
    if(this.configData.customFormFlag){
      this.selfServiceConfig = false;
    }
    else if(sessionStorage.getItem('isSelfServiceConfig'))
    {
      this.selfServiceConfig = true;
    }
    this.configData.groups.forEach(element => { 
      if(element.controls){
        element.controls.forEach(field => {
          if (element['dynamicVisibility']) {
            if(element['dynamicVisibility'].action == 'hidden'){
              this.hideSection = this.isAccessible(element['dynamicVisibility'].featureName);
              if(!this.hideSection){
                element['label'] = '';
                element['showDividerLine'] = false;
              }
            }
          }
          if (field['dynamicVisibility']) {
            if(field['dynamicVisibility'].action == 'hidden'){
              this.hideField = this.isAccessible(field['dynamicVisibility'].featureName);
              if(!this.hideField){
                field['cols'] = [];
              }
            }
          }
        });
      }
    });
  }

  stepperContentSubject;
  ngAfterViewInit() {

    let subj = new Subject();
    let stepperDetails;

    this.subscription = this.appService._stepperContentSubject.subscribe(res => {
      if (res) {
        let valid = true;
        this.totalError=0;
        if (res.stepperForm.validateForm) {
          this.totalError=0;
          // Run setFieldsAsRequired on all datepicker components first so errors are set before validity check
          let forms = res.stepperForm.validateForm.split(',');
          forms.forEach(form => {
            const formControls = this.frmGroup.controls[form]?.['controls']?.[0]?.controls;
            if (formControls) {
              Object.keys(formControls).forEach(field => {
                const component = this.appService._components[field];
                if (component?.configData &&
                  (component.configData.component === 'DATEPICKER' || component.configData.component === 'DATEPICKER_V2') &&
                  component.configData.enableStepperValidation &&
                  component.setFieldsAsRequired) {
                  component.setFieldsAsRequired();
                }
              });
            }
          });
          // No need to validate since the entire form itself is in disabled status 
          if (res.stepperForm.validateForm.indexOf(',')) {
            forms.some(form => {
              if (this.frmGroup.controls[form].disabled) {
                valid = true;
              } else {
                valid = this.frmGroup.controls[form].valid;
                if (!valid) {
                  return true;
                }
              }
            })
          } else {
            if (this.frmGroup.controls[res.stepperForm.validateForm].disabled) {
              valid = true;
            } else {
              valid = this.frmGroup.controls[res.stepperForm.validateForm].valid;
            }
          }
        }

        if (valid) {
          res.stepperDetails.forEach((element, i) => {

            if (res.stepperForm.validateForm.indexOf(',')) {
              let forms = res.stepperForm.validateForm.split(',');
              forms.some(form => {
                if (element.name === form) {
                  res.stepperDetails[i].valid = true;
                  stepperDetails = res.stepperDetails;
                }
              });
            } else {
              if (element.name === res.stepperForm.validateForm) {
                res.stepperDetails[i].valid = true;
                stepperDetails = res.stepperDetails;
              }
            }

            if (element.name === res.stepperForm.name) {
              let elem = document.getElementById(element.name);
              if (elem) {
                elem.style.transform = 'none';
                elem.style.visibility = 'visible';
                elem.style.height = '100%';
                elem.style.width = '100%';
                elem.style.overflow = 'unset';
              }
            }
            else {
              let elem = document.getElementById(element.name);
              if (elem) {
                elem.style.transform = 'translate3d(-100%, 0px, 0px)';
                elem.style.visibility = 'hidden';
                elem.style.height = '0';
                elem.style.overflowX = 'hidden';
              }

            }
          }, this);
          
          subj.next({ "stepper": stepperDetails, "invalidForm": false });

        } else {

          res.stepperDetails.forEach((element, i) => {

            if (res.stepperForm.validateForm.indexOf(',')) {
              let forms = res.stepperForm.validateForm.split(',');
              forms.some(form => {
                if (element.name === form) {
                  res.stepperDetails[i].valid = this.frmGroup.controls[form].valid;
                }
              });
            }

            //CP-8059 - start
            if(res.stepperForm.ignoreValidCheck){
              if (element.name === res.stepperForm.name) {             
                let elem = document.getElementById(res.stepperForm.name);
                if (elem) {
                  elem.style.transform = 'none';
                  elem.style.visibility = 'visible';
                  elem.style.height = '100%';
                  elem.style.width = '100%';
                  elem.style.overflow = 'unset';
                }
              }
              else {
                let elem = document.getElementById(element.name);
                if (elem) {
                  elem.style.transform = 'translate3d(-100%, 0px, 0px)';
                  elem.style.visibility = 'hidden';
                  elem.style.height = '0';
                  elem.style.overflowX = 'hidden';
                }
              }
            }
            //CP-8059 - end

          });

          if (res.stepperForm.validateForm.indexOf(',')) {
            let forms = res.stepperForm.validateForm.split(',');
            forms.some(form => {
              this.validateAllFormFields(this.frmGroup.controls[form]['controls'][0]);
              subj.next({ "stepper": stepperDetails, "invalidForm": true });
            });
          } else {
            this.validateAllFormFields(this.frmGroup.controls[res.stepperForm.validateForm]['controls'][0]);
            subj.next({ "stepper": stepperDetails, "invalidForm": true });
          }
          
        }
      }
    });
    return subj.asObservable();
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }

  drop(event: CdkDragDrop<string[]>,label) {
    this.configData.groups.forEach((elm, idx) => {
      if(label==elm.label){
      moveItemInArray(elm.controls, event.previousIndex, event.currentIndex);
      }
      })
  }
  
  removeFields(e,ctrl,id,crlIdx){
    if(sessionStorage.getItem("parentTemplate"))
      {
        let parentTemplate = JSON.parse(sessionStorage.getItem("parentTemplate"));
        parentTemplate.sections.forEach(group => {
            group.groups.forEach((elm, idx) => {
          if(id===idx){
          if (crlIdx !== -1) {
            group.groups[idx].controls.splice(crlIdx, 1);
        } 
      }   
    })
      })
      localStorage.setItem("parentTemplate",JSON.stringify(parentTemplate));
      console.log("UPDATED_TEMPLATE",parentTemplate);
      this.templatedata = JSON.parse(localStorage.getItem('templatedata'));
      let url
      console.log("res---------------",this.templatedata);
      if(localStorage.getItem('filterCurrenturl')=='/selfServiceListing/selfconfigdraft')
      {
        url = APP_Constants.UI_SELF_CONFIG_SAVE +localStorage.getItem('userName')
        +'&customerCode='+this.templatedata.customer_id
        +'&configId='+this.templatedata.template_id
        +'&action='+this.templatedata.action
      }
         else {
          url = APP_Constants.UI_SELF_CONFIG_SAVE +localStorage.getItem('userName')
        +'&customerCode='+this.templatedata.customer_id
        +'&configId='+this.templatedata.template_id
        +'&action='+this.templatedata.action
        +'&listingType='+"UIListing"
    }
  
      console.log("url--------",url,parentTemplate)
      this.appService.makeHttpPostRequest(url,parentTemplate).subscribe((data) => {
        if (data['message'].statusCode == APP_Constants.SUCCESS_CODE) {
          this.formError = ''
          this.isLoading = false;
          this.loadingStatus.emit(this.isLoading);
         // this.normalView();
          let preferenceId = data['data'].preferenceId;
          let saveDraftMsg = `Draft created`;
          let tempdata =  JSON.parse(localStorage.getItem('templatedata'))
          this.router.navigateByUrl('/selfServiceListing/'+tempdata.customer_id+ "-"+tempdata.action);
          window.location.reload()

          console.log("data----------",data)
         this._snackBar.open({ orderId: preferenceId, message: data['message'].statusMessage }, { duration: this.durationInSeconds * 1000 });
        }
      }, err => {
        this.isLoading = false;
        this.loadingStatus.emit(this.isLoading);
       // this.normalView();

        let modal = new Modal({
          action: false, name: 'Updated', title: 'Update Json ', description: err.message, actionButtonText: ''
        });
        this.modalService.createModalBox(modal, err.status);
      });
      }
  }
  
  // show/hide group with controls based on some other field action 
  toggleVisibility(hidden, groupname) {
    this.configData.groups.forEach(group => { 
      if(group.name === groupname){
        group['visibility'] = hidden;
        group.controls.forEach(control => {
          if(this.appService._components[control.name] && this.appService._components[control.name].toggleVisibility)
            this.appService._components[control.name].toggleVisibility(!hidden);
        })
      }
    });
    this.changeDetector.detectChanges();
  }

  getFormTableControls() {
    return this.frmGroup.controls[this.configData.name]['controls'];
  }

  getColumnsVisibility(control) {
    let cols = control.cols;
    let visibility = control.visibility;
    const mediaBreakpoints = ['xl', 'lg', 'md', 'sm', 'xs'];
    let colsClass = '';
    let zeroColumn: boolean = false;
    for (let i = 0; i < cols.length; i++) {
      if(cols[i] === "0")
        colsClass += 'col-' + mediaBreakpoints[i] + '-' + 'zeroColumn' + ' ';
      else
        colsClass += 'col-' + mediaBreakpoints[i] + '-' + cols[i] + ' ';
    }

    if (visibility === 'hidden') {
      colsClass += 'hidden';
    }

    // make control half width
    if(control.hasOwnProperty("makeDwarf") && control.makeDwarf){
      colsClass += 'dwarf' + ' ';
    }

    return colsClass;
  }

  editFieldConfig(sCancel, label,grouplabel)
  {
   if(this.configData.sections){
      this.configData.sections.forEach(section => {
        if(section.label==label){
          this.editField = true;
        if (this.configData !== null) {
          this.appService.setOrderTemplate(section);
          this.templateData = section
        }
      }
        })    
    }
    else if(label==='maintitle')
      {
        if (this.configData !== null) {
          this.editField = true;
          this.lableForConfig=label;
          this.appService.setOrderTemplate(this.configData.header);
          this.templateData =  this.configData.header
        }
      }
    else if(label==='addField'){
      this.editField = true;
      this.lableForConfig = label+"-"+grouplabel;
      this.configData.groups.forEach((elm, idx) => {
      this.appService.setOrderTemplate(elm.controls[1]);
      this.templateData = elm.controls[1]
      })
    }
    else if (label == 'updateField') {
      if (this.configData !== null) {
        this.editField = true;
        this.appService.setOrderTemplate(grouplabel);
        this.templateData = grouplabel
      }
    }
    else{
    this.configData.groups.forEach(group => {
      if(group.label==label){
        this.editField = true;
      if (this.configData !== null) {
        this.appService.setOrderTemplate(group);
        this.templateData = group
      }
    }
    })
  }
  

    if(sCancel == 'cancel')
    {
      this.editField = false; 
    }
  }

  
  getFormStatus(e) {
    this.orderFormSubmitted = e;
  }
  getForm(e) {
    this.orderForm = e;
  }

  // push it to service and use it from there
  validateAllFormFields(formGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      // Trigger custom validation for specific components before counting errors
      const component = this.appService._components[field];
      if (component && component.configData && 
          (component.configData.component === 'DATEPICKER' || component.configData.component === 'DATEPICKER_V2') &&
          component.configData.enableStepperValidation && 
          component.setFieldsAsRequired) {
          component.setFieldsAsRequired();
      }  
      if (control instanceof UntypedFormControl) {
        if (control.errors) {
        this.totalError += 1;
        if (control.errors.required) {
          control.markAsTouched({ onlySelf: true });
          control.markAsDirty({ onlySelf: true });
          control.updateValueAndValidity();
          }
        }
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      } else if (control instanceof UntypedFormArray) {
        control.controls.forEach(data => {
          this.validateAllFormFields(data);
        })
      } else if (control && control.errors) {
        // Handle other form control types that have errors
        this.totalError += 1;
        control.markAsTouched({ onlySelf: true });
        control.markAsDirty({ onlySelf: true });
        control.updateValueAndValidity();
      }
    });
  }
  isAccessible(roleAccess: string){
    let menuPages = JSON.parse(localStorage.getItem('menuPages'));
    return menuPages.includes(roleAccess) ;
  }  
} 
